import { RegisterStateDropdown } from "components/SalesTax/RegisterStateDropdown";

type RegisterStateCtaProps = {
  entityId: string;
  stateId: string;
  stateName: string;
};

export const RegisterStateCta = ({
  entityId,
  stateId,
  stateName,
}: RegisterStateCtaProps) => (
  <RegisterStateDropdown
    entityId={entityId}
    stateId={stateId}
    stateName={stateName}
    triggerLabel="Register now"
    triggerCustomType="secondary"
  />
);
